import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import Button from '../../../../../_components/Button';
import Text from '../../../../../_components/Text';

export default function OpenFinanceCategoriesModal({
    show,
    onHide,
    categories,
    onCreate,
    onDelete
}) {
    const [newName, setNewName] = React.useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!newName.trim()) return;
        onCreate(newName);
        setNewName('');
    };

    // Flatten categories for a simple list view
    const flatList = [];
    const flatten = (items, level = 0) => {
        if (!items) return;
        items.forEach(cat => {
            flatList.push({ ...cat, level });
            if (cat.children && cat.children.length > 0) {
                flatten(cat.children, level + 1);
            }
        });
    };
    flatten(categories);

    return (
        <Modal show={show} onHide={onHide} size="md" centered>
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="h5 font-weight-bold">Gerenciar Plano de Contas</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4">
                    <Text className="font-weight-bold mb-2">Adicionar Nova Categoria</Text>
                    <Form onSubmit={handleSubmit} className="d-flex">
                        <Form.Control
                            type="text"
                            placeholder="Ex: Aluguel, Vendas, etc."
                            value={newName}
                            onChange={e => setNewName(e.target.value)}
                            className="mr-2"
                        />
                        <Button type="submit" variant="primary" size="slim">
                            <i className="fas fa-plus mr-1" /> Criar
                        </Button>
                    </Form>
                </div>

                <Text className="font-weight-bold mb-2">Categorias Atuais</Text>
                <div className="border rounded bg-light p-2" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {flatList.length === 0 ? (
                        <div className="text-center py-4 text-muted small">
                            Nenhuma categoria cadastrada.
                        </div>
                    ) : (
                        flatList.map(cat => (
                            <div
                                key={cat.id}
                                className="d-flex justify-content-between align-items-center p-2 mb-1 bg-white rounded border-bottom shadow-xs"
                                style={{ marginLeft: `${cat.level * 20}px` }}
                            >
                                <Text className="mb-0 ml-1">
                                    {cat.level > 0 && <i className="fas fa-long-arrow-alt-right mr-2 text-muted opacity-50" />}
                                    {cat.name}
                                </Text>
                                <Button
                                    variant="outline-danger"
                                    size="slim"
                                    as="text"
                                    onClick={() => onDelete(cat.id)}
                                    title="Remover Categoria"
                                >
                                    <i className="fas fa-trash-alt text-danger" />
                                </Button>
                            </div>
                        ))
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/OpenFinance/components/OpenFinanceCategoriesModal.jsx